<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Your Donation">
                    <FormRow class="amounts">

                      <AmountSelectorList :nocustom="true"/>
                      <ErrorLabel field="amount" />
                    </FormRow>
                    <!-- <FormRow>
                      <Receipt :receipts="['us','israel']"/>
                    </FormRow> -->
                </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline class="israeli-tax-id-row"> <FormCol field="taxId" label="Teudat Zehut" placeholder="" /> </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>
                    <FormRow inline>
              <div style="width: 100%padding-top: 25px;">
                <FormLabel class="control-label dedicaton__label"> Help encourage others to join Sparks as well! Please share your preferred full name to be included on Sparks marketing materials. <br><i>(If you prefer to remain anonymous please write Anonymous.)</i></FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.dedication"
                />
              </div>
              </FormRow>
                    <FormRow inline>

              <FormCol field="custom.shirtSize" width="half" :showLabel="false">
                    <FormLabel class="control-label">Shirt Size: </FormLabel>
                    <FormSelect>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                </FormSelect>

                </FormCol>
              </FormRow>



                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                  <FormRow>
                      <label class="control-label"
                      ><input
                          type="checkbox"
                          :checked="getValue('custom.conditions')"
                          @click="setValue('custom.conditions', $event.target.checked)"
                      />
                      By clicking you accept our <a href="https://www.ouisrael.org/privacy-policy/" target="_blank">Terms and Conditions</a></label
                      >
                  </FormRow>
                  <br/>
                  <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                  </FormRow>
                </FormSection>
                <PaymentButton btnText="Submit"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form'
import { defineComponent } from 'vue'

export default defineComponent({
  setup(props) {
	  const { form, setValue, getValue } = usePaymentForm()
    setValue("dayOfMonth", "" + new Date().getDate());
    setValue("periodMonths", null);
	  return {
		  form,
      setValue,
      getValue
	  }
  }
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .radio-inline {
  margin-left: 20px !important;
}
.options ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: flex-start;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {

}



.amounts {
  margin-top: 2rem;
}
.amounts ::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount-row {
      min-width: 48%;
    max-width: 48%;
    margin-bottom: 7px;
      @media (min-width: 720px) {
  min-width:24%;
  max-width:24%;
  margin-bottom: 15px;
      }

      input[type="radio"]:checked + label,
  input[type="radio"]:checked + label .label-amount {
   color: black;
  }

  label {
    background: black;
    color: white;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    font-size: 20px;

    .money_format.label-amount{
      &::after{
        content: " Monthly";
        font-weight: 600;
        font-size: 13px;
        font-style: italic;
        padding-left: 3px;
      }
    }
  }
  &:nth-child(1){

  label {
    border: 5px solid #bb7917;
  }
  input[type="radio"]:checked + label,
  input[type="radio"]:checked + label .label-amount {
    background: #bb7917;
    border-color: #bb7917;
  }

}
  &:nth-child(2) {
    label {
      border: 5px solid silver;
  }
  input[type="radio"]:checked + label,
  input[type="radio"]:checked + label .label-amount {
    background: silver;
    border-color: silver;
  }
}
  &:nth-child(3) {
    label {    border: 5px solid gold;
  }
  input[type="radio"]:checked + label,
  input[type="radio"]:checked + label .label-amount {
    background: gold;
    border-color: gold;
  }
}
  &:nth-child(4) {
    label {    border: 5px solid #a0eaea;
}
input[type="radio"]:checked + label,
  input[type="radio"]:checked + label .label-amount {
    background: #a0eaea;
    border-color: #a0eaea;
  }
  }
  .label-amount {
    background: black;
    border: none;
    padding-top: 5px;
    padding-bottom: 0;
  }
  .label-description {
    font-size: 16px;
    padding-bottom: 0;
    padding-top: 5px;
  }
}
::v-deep .ou-donation-btn {
  background: #bb7917;
  border-color: #bb7917;
  &:hover {
    background: black;
    border-color: black;
  }
}
::v-deep label.radio-inline {
  line-height: 1.4;
}
::v-deep label.dedicaton__label{
  line-height: 1.3;
  }
</style>

